import DescriptionMetaDate from './DescriptionMetaDate';
import DescriptionMetaSeparator from './DescriptionMetaSeparator';
import * as S from './styles';

const DescriptionMetadata = Object.assign(S.DescriptionMetadata, {
  Date: DescriptionMetaDate,
  Separator: DescriptionMetaSeparator,
});

export type DescriptionMetadataProps = React.PropsWithoutRef<
  typeof DescriptionMetadata
>;

export default DescriptionMetadata;
